import { action, computed, observable } from 'mobx';
import { setter, toggle } from 'mobx-decorators';
import * as constants from 'Constants';
import { deserializeWithMappers, setFieldValues } from 'stores/Utils';


class OptionStore {

  @setter @observable id;
  @setter @observable label;

  static create(data={}) {
    const instance = new OptionStore();
    setFieldValues(instance, data);
    return instance;
  }

  static getDefaults() {
    return {
      "id": null,
      "label": "",
    };
  }

  constructor(defaults=OptionStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  @action reset(defaults=OptionStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  getDeserializeMappers() {
    return [
      {"field": "id"},
      {"field": "label"},
    ];
  }

  @action deserialize(data) {
    deserializeWithMappers(this, this.getDeserializeMappers(), data);
  }
}



export default OptionStore;

